import React from 'react'

import {
  EnterpriseBadge,
  FreeBadge,
  ProBadge,
  RMSubscriptionBadge,
  StarterBadge
} from 'components/common/Badge'
import { PricingPlanTier } from 'types/api/companies/contracts'
import { Company } from 'types/api/rbac/company'

interface PlanBadgeProps {
  company: Company
}

export const PLANS = {
  ENTERPRISE: PricingPlanTier.Enterprise,
  PRO: PricingPlanTier.Pro,
  STARTER: PricingPlanTier.Starter,
  FREE: PricingPlanTier.Free,
  RMSUBSCRIPTION: PricingPlanTier.RMSubscription
}

export const getPlanType = (company) => {
  // handle new pricing plans
  if (company.pricing_plan_name) {
    return company.pricing_plan_name
  }
  // and legacy contracts
  return company.tier === PLANS.ENTERPRISE ? null : PLANS.FREE
}

const PlanBadge: React.FC<PlanBadgeProps> = ({ company }) => {
  if (company?.pricing_plan_name || company?.tier) {
    switch (getPlanType(company)) {
      case PLANS.RMSUBSCRIPTION:
        return <RMSubscriptionBadge />

      case PLANS.ENTERPRISE:
        return <EnterpriseBadge />

      case PLANS.PRO:
        return <ProBadge />

      case PLANS.STARTER:
        return <StarterBadge />

      case PLANS.FREE:
        return <FreeBadge />

      default:
        return null
    }
  }

  return null
}

export default PlanBadge
